import type AuthConnector from "../data/authConnector";
import type { IPagedResults, IPagination } from "../data/types";
import PermissionArea from "entities/permissionArea";
import type EventBus from "services/eventBus";
import FaultyCombination from "../entities/faultyCombination";
import RepositoryBase from "./repositoryBase";
import type { IListRepository } from "./types";
import PermissionAreaWithFaultyCombinationsResponse from "../entities/permissionAreaWithFaultyCombinationsResponse";
import snakeCaseKeys from "../utils/snakeCaseKeys";

export default class PermissionAreaRepository extends RepositoryBase<AuthConnector> implements IListRepository<PermissionArea> {
  constructor(protected apiFactory: ReturnType<typeof AuthConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  get(id: string) {
    return this.callApi(api => api.one("permission_areas", id).getEntity<PermissionArea>(PermissionArea));
  }

  getAll(pagination: IPagination) {
    return this.callApi(api => api.all("permission_areas").get<IPagedResults<PermissionArea>>(pagination));
  }

  getAllFaultyCombinations(areaId?: string) {
    return this.callApi(api =>
      api
        .all("permission_areas")
        .all("faulty_combinations")
        .getPagedEntities<PermissionAreaWithFaultyCombinationsResponse>(
          PermissionAreaWithFaultyCombinationsResponse,
          snakeCaseKeys({ areaId })
        )
    );
  }

  getFaultyCombinations(permissionAreaId: string) {
    return this.callApi(api =>
      api.one("permission_areas", permissionAreaId).all("faulty_combinations").getEntity<FaultyCombination>(FaultyCombination)
    );
  }

  updateFaultyCombinations(permissionAreaId: string, faultyCombinations: any) {
    return this.callApi(api =>
      api.one("permission_areas", permissionAreaId).all("faulty_combinations").put<FaultyCombination>(faultyCombinations)
    );
  }
}
